export default __webpack_public_path__ + "static/media/Creating Orders - Delivery and Pickup.8c455d8e.pdf";